<div class="flex flex-column gap pt-2">
    <div>{{ prefix + 'message.refValues' | translate }}</div>
    <app-number-input
        id="payment"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [min]="0"
        [disabled]="form()!.value.direct ?? false"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.paymentDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <app-number-input
        id="pumRef"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [disabled]="form()!.value.direct ?? false"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.pumRefDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <app-switch-input
        id="direct"
        [form]="form()!"
        [label]="prefix + 'fields.direct'"
    ></app-switch-input>

    <app-number-input
        id="pmupRef"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [disabled]="!form()!.value.direct"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.pmupRefDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

</div>
